module.exports = __webpack_public_path__ + "img/google-play.135ee4d7.svg";